function NotFound() {
    return <h1>404 - Página não encontrada</h1>;
}
  
export default NotFound;